import React, { ComponentType, FC, lazy } from "react";

export const withLazyDialog = <TProps extends object>(
  factory: () => Promise<{ default: ComponentType<TProps> }>
): FC<TProps> => {
  const LazyComponent = lazy(factory) as unknown as FC<TProps>;

  const LazyDialog: FC<TProps> = (props) => {
    return (
      <React.Suspense fallback={null}>
        <LazyComponent {...props} />
      </React.Suspense>
    );
  };

  return LazyDialog;
};
